<template>
  <v-autocomplete
    v-model="selectedId"
    :items="displayItems"
    :search-input="searchQuery"
    :loading="loading"
    item-value="id"
    :item-text="itemText"
    placeholder="Digite para pesquisar..."
    :no-data-text="emptyListText"
    clearable
    no-filter
    background-color="white"
    :label="label"
    :outlined="true"
    :dense="true"
    :hide-details="!errorMessages"
    :error-messages="errorMessages"
    :disabled="disabled"
    @update:search-input="updateSearchQuery"
  />
</template>

<script>
export default {
  name: "SearchDropdown",
  data() {
    return {
      searchQuery: "",
      selectedId: null,
      debounceTimer: null,
      displayItems: [],
      isSearching: false,
    };
  },
  props: {
    value: {
      required: false,
      default: () => null,
    },
    searchResultItems: {
      type: Array,
      required: false,
      default: () => [],
    },
    itemText: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    debounceTime: {
      type: Number,
      required: false,
      default: 500,
    },
    inputPromptText: {
      type: String,
      required: true,
    },
    notFoundText: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    errorMessages: {
      type: [String, Array],
      required: false,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  created() {
    this.updateSelectionAndQuery();
  },
  computed: {
    emptyListText() {
      if (!this.searchQuery || this.isSearching) {
        return this.inputPromptText;
      }

      return this.notFoundText;
    },
    hasSearchResults() {
      return this.searchResultItems.length > 0;
    },
    selectedItemSearchString() {
      if (!this.value) return;

      return this.value[this.itemText];
    },
  },
  watch: {
    searchQuery() {
      this.debounceSearch();
    },
    selectedId(id) {
      this.updateSelectedValue(id);
    },
    value() {
      this.updateSelectionAndQuery();
    },
    searchResultItems(items) {
      this.displayItems = items;
      this.isSearching = false;
    },
  },
  methods: {
    updateSearchQuery(value) {
      if (!value) return;

      this.searchQuery = value;
    },
    debounceSearch() {
      clearTimeout(this.debounceTimer);

      this.isSearching = true;
      this.debounceTimer = setTimeout(
        () => this.triggerSearch(),
        this.debounceTime
      );
    },
    triggerSearch() {
      if (!this.searchQuery) return;

      this.$emit("search", this.searchQuery);
    },
    updateSelectionAndQuery() {
      if (this.value === null) {
        this.selectedId = null;
        this.searchQuery = null;
      }

      if (!this.value) return;

      this.searchQuery = this.selectedItemSearchString;
      this.selectedId = this.value.id;
    },
    updateSelectedValue(id) {
      const newValue = this.findItemById(id);

      if (typeof newValue === "undefined") return;

      this.$emit("input", newValue);
      this.$emit("change", newValue);
    },
    findItemById(id) {
      return this.displayItems.find((item) => item.id === id);
    },
  },
};
</script>

<style scoped></style>
